import React, { useState } from 'react';

// Every chart ships with a table twin. Colour and position are never the only
// way to read a value — the table is the WCAG-clean equivalent, and it is also
// what someone reaches for when they want the exact number.
const ChartCard = ({ title, subtitle, action, children, table, empty, height }) => {
  const [showTable, setShowTable] = useState(false);

  return (
    <section className="bg-card rounded-2xl border border-border/40 p-5 shadow-sm">
      <header className="flex items-start justify-between gap-3 mb-4">
        <div className="min-w-0">
          <h3 className="text-sm font-bold text-foreground">{title}</h3>
          {subtitle && <p className="text-xs text-muted-foreground mt-0.5 font-medium">{subtitle}</p>}
        </div>
        {action}
      </header>

      {empty ? (
        <div className="flex flex-col items-center justify-center text-center gap-1" style={{ height: height || 200 }}>
          <p className="text-sm font-semibold text-foreground">{empty.title}</p>
          <p className="text-xs text-muted-foreground max-w-xs">{empty.hint}</p>
        </div>
      ) : (
        children
      )}

      {table?.rows?.length > 0 && !empty && (
        <div className="mt-3 pt-3 border-t border-border/40">
          <button
            onClick={() => setShowTable((prev) => !prev)}
            aria-expanded={showTable}
            className="text-[11px] font-bold text-muted-foreground hover:text-foreground bg-transparent border-none cursor-pointer p-0 transition-colors"
          >
            {showTable ? 'Hide values' : 'Show values'}
          </button>
          {showTable && (
            <div className="mt-3 max-h-52 overflow-y-auto">
              <table className="w-full text-[11px]">
                <thead>
                  <tr>
                    {table.head.map((h, i) => (
                      <th
                        key={h}
                        scope="col"
                        className={`py-1.5 font-bold text-muted-foreground ${i === 0 ? 'text-left' : 'text-right'}`}
                      >
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {table.rows.map((row, i) => (
                    <tr key={i} className="border-t border-border/30">
                      {row.map((cell, j) => (
                        <td
                          key={j}
                          className={`py-1.5 ${j === 0 ? 'text-left text-muted-foreground' : 'text-right font-bold text-foreground tabular-nums'}`}
                        >
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </section>
  );
};

export default ChartCard;
